module.exports = __webpack_public_path__ + "img/graphe-couleur-appli-ln.962f13b9.png";